import { Handle, Position, NodeResizer, type NodeProps } from "@xyflow/react";
import { HelpCircle } from "@untitledui/icons";
import { useTranslation } from "react-i18next";

export const DecisionNode = ({ data, selected }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const label = (data?.label as string) || t('workflows.editor.defaultLabels.decision');

    return (
        <div className="relative w-full h-full min-w-[150px] min-h-[100px]">
            <NodeResizer
                color="#f59e0b"
                isVisible={selected}
                minWidth={150}
                minHeight={100}
            />
            {/* Border layer - slightly larger */}
            <div
                className="absolute inset-0 bg-utility-warning-500 shadow-md"
                style={{
                    clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
                }}
            />
            {/* Content layer - slightly smaller to create border effect */}
            <div
                className="absolute inset-[2px] bg-utility-warning-50"
                style={{
                    clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
                }}
            />
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-warning-500" />
            <Handle type="source" position={Position.Bottom} id="yes" className="w-3 h-3 bg-utility-success-500" />
            <Handle type="source" position={Position.Bottom} id="no" className="w-3 h-3 bg-utility-error-500" />
            <Handle type="source" position={Position.Left} id="left" className="w-3 h-3 bg-utility-warning-500" />
            <Handle type="source" position={Position.Right} id="container" className="w-3 h-3 bg-utility-blue-500" />
            <div className="absolute inset-0 flex flex-col gap-1 items-center justify-center text-center px-3 py-2 pointer-events-none">
                <div className="flex items-center gap-2 flex-wrap justify-center max-w-full">
                    <HelpCircle className="size-4 text-utility-warning-600 flex-shrink-0" />
                    <span className="text-sm font-semibold text-utility-warning-700 break-words whitespace-normal">{label}</span>
                </div>
            </div>
        </div>
    );
};
